export default "/_next/static/fonts/Graphik-RegularItalic-82dc76075a9b8bf893442f58c61ddc14.woff2";